export default __webpack_public_path__ + "static/MIHAEL-0d4cdcf2d4dae64f9590711d81a87f1c.jpg";